module.exports = __webpack_public_path__ + "img/Accidentes al Conductor.0cda9062.svg";